import { startWith, map } from 'rxjs/operators';
import { tap } from 'rxjs/operators';
import { take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { UntypedFormControl, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {
  Component,
  OnInit,
  forwardRef,
  ViewEncapsulation,
  Input,
  ChangeDetectorRef,
} from '@angular/core';

import { ServicesSubject } from '@services/outros/services-subjects.service';
import { Helper } from '@utils/helper';
import { LocalAtendimentoDetranModel } from '@core/models/gestao/local-atendimento-detran-model';
import { LocalAtendimentoDetranService } from '@core/services/apis/gestao/local-atendimento-detran.service';

export const DETRAN_AUTOCOMPLETE_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => LocalAtendimentoDetranAutocompleteComponent),
  multi: true,
};

@Component({
  selector: 'app-local-atendimento-detran-autocomplete',
  templateUrl: './local-atendimento-detran-autocomplete.component.html',
  styleUrls: ['./local-atendimento-detran-autocomplete.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DETRAN_AUTOCOMPLETE_CONTROL_VALUE_ACCESSOR],
})
export class LocalAtendimentoDetranAutocompleteComponent implements OnInit, ControlValueAccessor {
  @Input() fControl: UntypedFormControl = new UntypedFormControl();
  @Input() itemProperty: string;
  @Input() label: string = '';
  items: LocalAtendimentoDetranModel[] = [];
  filteredItems: Observable<LocalAtendimentoDetranModel[]>;
  required: string = '';
  private innerValue: any = '';

  constructor(
    private _serviceLocalAtendimentoDetran: LocalAtendimentoDetranService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.loadItens();
    this.required = Helper.checkIsRequired(this.fControl);
  }

  loadItens() {
    this._serviceLocalAtendimentoDetran
      .getAll({Ativo: true})
      .pipe(take(1))
      .subscribe({
        next: (res) => {
          if (res) {
            this.items = Helper.sortItems(Helper.changeToUpercase(res, 'nome'), 'nome');

            this.filteredItems = this.fControl.valueChanges.pipe(
              startWith(''),
              map((value) => this.filterItems(value)),
            );
          } else {
            this.items = [];
          }
          this.cdr.detectChanges();
        },
        error: (err) => {
          console.error('Erro na API:', err);
          this.items = [];
          this.cdr.detectChanges();
        },
      });
  }

  private filterItems(value: any): LocalAtendimentoDetranModel[] {
    if (!this.items) return [];

    const filterValue =
      typeof value === 'string' ? value.toLowerCase() : value?.nome?.toLowerCase() || '';

    return this.items.filter((item) => item.nome.toLowerCase().includes(filterValue));
  }

  getName = (value: any) => {
    if (!value) return '';

    // Se for um objeto completo
    if (typeof value === 'object') {
      return value.nome || '';
    }

    // Se for apenas o ID/propriedade
    const item = this.items?.find((i) =>
      this.itemProperty ? i[this.itemProperty] === value : i === value,
    );

    return item?.nome || '';
  };

  clear(event) {
    if (this.fControl.disabled) return;
    this.fControl.setValue('');
    event.preventDefault();
  }

  writeValue(value: any): void {
    this.innerValue = value;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {}

  setDisabledState?(isDisabled: boolean): void {}

  propagateChange = (_: any) => {};

  private _filter(value: any): LocalAtendimentoDetranModel[] {
    const filterValue = value && value.nome ? value.nome.toLowerCase() : value.toLowerCase();
    return this.items.filter((item) => item.nome.toLowerCase().includes(filterValue));
  }

  private _filterById(value: any): LocalAtendimentoDetranModel[] {
    return this.items.filter((item) => item.id == value);
  }
}
